import { Star } from "lucide-react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { ProductMultiSelect } from "@/components/ProductMultiSelect";

interface Props {
  products: { id: string; name: string }[];
  value: string[];
  primaryId: string;
  onChangeProducts: (ids: string[]) => void;
  onChangePrimary: (id: string) => void;
}

// Seleção de produtos da OP + marcação do produto PRINCIPAL (clarify Q5: é o
// produto usado no mapeamento 1:1 com SimulationBatch). Default do principal = 1º selecionado.
export function ProductsPrimaryField({
  products,
  value,
  primaryId,
  onChangeProducts,
  onChangePrimary,
}: Props) {
  const selected = products.filter((p) => value.includes(p.id));
  return (
    <div className="space-y-2">
      <Label>
        Produtos{" "}
        <span className="text-[11px] font-normal text-text-tertiary">· N produtos por OP</span>
      </Label>
      <ProductMultiSelect products={products} value={value} onChange={onChangeProducts} />
      {selected.length > 0 ? (
        <div className="space-y-1 rounded-md border bg-muted/30 p-2">
          <p className="text-[11px] text-text-secondary">Produto principal</p>
          {selected.map((p) => (
            <label key={p.id} className="flex cursor-pointer items-center gap-2 text-sm">
              <input
                type="radio"
                name="po-primary"
                checked={primaryId === p.id}
                onChange={() => onChangePrimary(p.id)}
                className="h-4 w-4"
              />
              <Star
                className={cn(
                  "h-3.5 w-3.5",
                  primaryId === p.id ? "text-rd-warning-500" : "text-text-tertiary"
                )}
              />
              {p.name}
            </label>
          ))}
        </div>
      ) : null}
    </div>
  );
}
